import { useEffect, useState } from "react";
import { GitBranch } from "lucide-react";
import api from "../api";
import { Reveal } from "../components/motion";

const TYPE_STYLES = {
  Added: "text-emerald-400 border-emerald-400/30 bg-emerald-400/10",
  Changed: "text-volt border-volt/30 bg-volt/10",
  Fixed: "text-amber-400 border-amber-400/30 bg-amber-400/10",
  Removed: "text-red-400 border-red-400/30 bg-red-400/10",
};

export default function Changelog() {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    api.get("/public/changelog").then((r) => setEntries(r.data)).catch(() => {});
  }, []);

  return (
    <main className="pt-16 min-h-screen" data-testid="changelog-page">
      <section className="hero-glow border-b border-white/10">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-20">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.35em] text-volt font-semibold mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-volt inline-block" /> Updates
            </p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight" style={{ fontWeight: 900 }} data-testid="changelog-headline">
              SHIPPED, <span className="text-outline">NOT PROMISED.</span>
            </h1>
            <p className="text-muted-foreground text-base md:text-lg mt-6 max-w-xl">
              Every version, every fix, in the open. GrooveMusic is maintained in public.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-5 sm:px-8 py-16">
        <div className="relative border-l-2 border-white/10 ml-3 space-y-12" data-testid="changelog-list">
          {entries.map((e, i) => (
            <Reveal key={e.id} delay={i * 0.05}>
              <div className="relative pl-10" data-testid={`changelog-${e.version}`}>
                <span className="absolute -left-[11px] top-1 w-5 h-5 rounded-full bg-void border-2 border-blurple flex items-center justify-center">
                  <GitBranch size={10} className="text-blurple" />
                </span>
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="font-mono text-volt font-semibold">{e.version}</span>
                  <span className="text-xs font-mono text-white/35">{new Date(e.date).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}</span>
                </div>
                <h3 className="font-heading text-xl font-bold text-white mt-2">{e.title}</h3>
                <ul className="mt-5 space-y-2.5">
                  {e.changes.map((c, j) => (
                    <li key={j} className="flex items-start gap-3 text-sm text-muted-foreground">
                      <span className={`shrink-0 text-[10px] font-mono uppercase tracking-wider border rounded-full px-2 py-0.5 mt-0.5 ${TYPE_STYLES[c.type] || TYPE_STYLES.Changed}`}>
                        {c.type}
                      </span>
                      {c.text}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
